import { CommonModule } from '@angular/common';
import { HttpClientJsonpModule, HttpClientModule } from '@angular/common/http';
import { Component, OnInit, ViewChild, inject } from '@angular/core';

import assert from 'tiny-invariant';

import { IonicModule } from '@ionic/angular';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FocusableMixin } from '@ts/shared/form/focus/util-core';
import { GoogleMapsScriptLoaderService } from '@ts/shared/google-maps/util-core';
import { SharedUiAwaitSpinnerModule } from '@ts/shared/ui-await-spinner';

import { AddressUiFieldComponent } from '../address-ui/address-ui.field.component';
import { AddressFieldModel } from '../address.field.model';

@Component({
  selector: 'ts-address-field',
  styleUrls: ['./address.field.component.scss'],
  templateUrl: './address.field.component.html',
  imports: [
    CommonModule,
    IonicModule,
    HttpClientModule,
    HttpClientJsonpModule,
    SharedUiAwaitSpinnerModule,
    AddressUiFieldComponent,
  ],
})
export class AddressFieldComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit, FocusableMixin
{
  private googleMapsApiLoaderService = inject(GoogleMapsScriptLoaderService);

  @ViewChild(AddressUiFieldComponent)
  addressUiFieldComponent!: AddressUiFieldComponent;

  isScriptLoaded$ = this.googleMapsApiLoaderService.isScriptLoaded$;
  addressFieldModelInitial?: AddressFieldModel;

  setFocus() {
    this.addressUiFieldComponent.setFocus();
  }

  ngOnInit() {
    if (this.formControl.value) {
      this.addressFieldModelInitial = this.formControl.value;
    }
  }

  placeSelected(place: google.maps.places.PlaceResult | null) {
    if (!place) {
      this.formControl.setValue(null);
      this.formControl.setErrors({
        addressInvalid: true,
      });
    } else {
      assert(place.formatted_address);
      assert(place.place_id);
      assert(place.geometry);
      assert(place.geometry.location);
      const addressFieldModel: AddressFieldModel = {
        address: place.formatted_address,
        place_id: place.place_id,
        geolocation: {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        },
      };
      this.formControl.setValue(addressFieldModel);
    }
  }
}
